import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule, CommonUIFieldsModule } from '@sdbn/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { QRCodeModule } from 'angularx-qrcode';
import { CenteredScrollableContentModule } from '@sdbn/tmc-common';
import { GlobalConnectAppDialog } from './component/global-connect-app-dialog';
import { TransportRegistrationSmartphoneConnectionComponent } from './component/transport-registration-smartphone-connection.component';
import { MatRadioModule as MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    TransportRegistrationSmartphoneConnectionComponent,
    GlobalConnectAppDialog
  ],
  imports: [
    CommonModule,
    CommonUIModule,

    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    CenteredScrollableContentModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    MatRadioModule,
    MatDialogModule,
    CommonUIFieldsModule
  ]
})
export class TransportRegistrationSmartphoneConnectionModule { }
